import { OrderApis } from "../apis/OrderApis";

export const OrderServices = {
  fetchOrders: async () => {
    const response = await OrderApis.fetchOrders();
    return response;
  },

  updateOrderStatus: async (data) => {
    const response = await OrderApis.updateOrderStatus(data);
    if (!response.success) {
      return {
        success: false,
        status: 400,
        message: "There was an error updating this order status",
      };
    }
    return response.data;
  },

  updateOpenStatus: async () => {
    const response = await OrderApis.updateOpenStatus();
    if (!response.success) {
      return {
        success: false,
        status: 400,
        message: "There was an error updating this order status",
      };
    }
    return response.data;
  },

  rejectOrder: async (orderNumber, reason) => {
    const response = await OrderApis.rejectOrder(orderNumber, reason);
    if (!response.success) {
      return {
        success: false,
        status: 400,
        message: "There was an error rejecting this order",
      };
    }
    return response.data;
  },
};
